module.exports = __webpack_public_path__ + "static/media/013.7d9d5f94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/013.jpg
// module id = 360
// module chunks = 0